module.exports = __webpack_public_path__ + "xmr_icon.svg?d8ace92feda2a87e89037a34bb1db871";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/xmr_icon.svg
// module id = 1149
// module chunks = 2